// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".thumbnail-item[data-v-a56c67ac]{border-radius:8px;overflow:hidden;position:relative;width:100%}.thumbnail-item>img[data-v-a56c67ac]{aspect-ratio:16/9}@supports not (aspect-ratio:16/9){.thumbnail-item>img[data-v-a56c67ac]{position:absolute}.thumbnail-item[data-v-a56c67ac]:before{content:\"\";float:left;padding-top:56.25%}.thumbnail-item[data-v-a56c67ac]:after{clear:both;content:\"\";display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
